import type { CompareHeroProps } from '@/components/pet/compare/CompareHero';
import type { CompareReviewsProps } from '@/components/pet/compare/CompareReviews';
import type { CompareTableProps } from '@/components/shared/CompareTable';
import type { BasePageConfig } from '../../../BasePageConfig';
import { config as enConfig } from './en';

interface Config extends BasePageConfig {
  hero: CompareHeroProps;
  compareTable: CompareTableProps;
  compareReviews: Omit<CompareReviewsProps, 'show'>;
}

export const config: Config = {
  ...enConfig,
  seo: {
    ...enConfig.seo,
    noIndex: true,
    uniqueCanonicalUrl: 'https://www.lemonade.com/pet-compare',
  },
  hero: {
    ...enConfig.hero,
    mainCta: 'Check our prices',
  },
};
